var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('al-apply',{key:_vm.$route.fullPath,attrs:{"editInfo":_vm.params,"fromEnrollParams":_vm.fromEnrollParams}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }